import { Injectable, inject } from '@angular/core';
import { AUTH_CONFIG } from './auth.config';

const SIDE_BAR_STATUS = 'SIDE_BAR_STATUS';

/** localStorage facade. The user object shape belongs to the app; ask for it typed: getUser<SalonStaff>(). */
@Injectable({ providedIn: 'root' })
export class StorageService {
  // optional so a bare TestBed can use the service. every app provides it through provideAuth().
  private readonly userKey = inject(AUTH_CONFIG, { optional: true })?.userStorageKey ?? 'USER';

  getUser<T>(): T | null {
    const raw = localStorage.getItem(this.userKey);
    return raw ? (JSON.parse(raw) as T) : null;
  }

  saveUser(user: unknown): void {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  clean(): void {
    localStorage.clear();
  }

  saveSideBarStatus(status: boolean): void {
    localStorage.setItem(SIDE_BAR_STATUS, String(status));
  }

  /**
   * Open unless the user collapsed it. Nothing stored means a fresh sign-in,
   * since clean() wipes the key on sign-out, and the rail is the way around
   * the app, so it starts open. Only an explicit 'false' written by the
   * sidebar's own toggle collapses it.
   */
  getSideBarStatus(): boolean {
    return localStorage.getItem(SIDE_BAR_STATUS) !== 'false';
  }
}
